import { AxiosInstance } from "axios"
import { SubscriptionOrder } from "../../../../company/reports/accounting/subscriptions/subscriptionsTypes"

export enum SupportSubscriptionQuery {
    SUBSCRIPTIONS_FOR_SUPPORT_REPORTS = "subscriptions-for-support-reports",
}

type SubscriptionsForSupportParams = Readonly<{
    orderId?: string
    subscriptionIds?: string
    startDate?: string
    endDate?: string
    merchantId?: string
    merchantIds?: string
    shopIds?: string
    customerId?: string
    userGroupId?: string
    email?: string
    paymentMethods?: string
    creditCardLast4?: string
}>

export type SubscriptionsForSupportResponse = Readonly<{
    orders: SubscriptionOrder[]
}>

export async function fetchSubscriptionsForSupport(
    params: SubscriptionsForSupportParams,
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<SubscriptionsForSupportResponse> {
    const url = "/accounting/subscriptions/orders"

    const { data } = await axios.get(url, {
        params,
        signal,
    })

    return data
}
